import moment from 'moment'
import { AddApplicantAvailabilityFormData } from '../types/applicantAvailability'
import { Application } from '../types/applications'

const getApplicationNameFromId = (
  applicationNameIdPairs: any[] | undefined,
  id: string
): string => {
  if (applicationNameIdPairs && applicationNameIdPairs.length > 0) {
    return applicationNameIdPairs.find((application) => application.id === id)
      ?.name
  } else {
    return ''
  }
}
const futureAvailabiliy = (el: AddApplicantAvailabilityFormData) => {
  return moment().hour(0).minutes(0).isBefore(el.startTime)
}

const isSuperLikeActive = (application: Application | undefined | null) => {
  if (!application || !application.rights) return false
  return Array.isArray(application.rights) && application.rights.includes('14')
}

export {
  getApplicationNameFromId,
  futureAvailabiliy,
  isSuperLikeActive
}
